import {apiConstants} from "@data/constants/apiConstants";
import {schoolsService} from "@data/services/schoolsService";

// ** Initial State
const initialState = {
    list: []
};

function schools(state = initialState, action) {
    switch (action.type) {
        case schoolsService.getSchool.name + apiConstants._SUCCESS:

            return {
                ...state,
                list: state?.list?.find(s => s.id === action.data?.id) ? state?.list?.map(s => s.id === action.data?.id ? action.data : s) : state?.list?.concat(action.data)
            }

        case schoolsService.getSchools.name + apiConstants._SUCCESS:
            let list = [];
            if (action.data?.meta?.current_page === 1) {
                list = action.data?.schools;
            } else {
                list = state.list?.concat(
                    action.data?.schools
                );
            }
            return {
                ...state,
                list
            };
        default:
            return state;
    }
}

export default schools;
